import FloatMenu from "./FloatMenu";

import { useEffect, useState } from "react";
import { modifyMegaMenuTreeData } from "@/helpers/category";
import { useRouter } from "next/router";
import { useClient } from "@/hooks/useClient";
import Link from "next/link";

const MegaMenu = ({ megaMenuTreeData }) => {
  const [isMenuOpen, setIsMenuOpen] = useState("");
  const { isClient } = useClient();

  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = () => {
      setIsMenuOpen("");
    };

    router.events.on("routeChangeStart", handleRouteChange);

    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, [router.events]);

  const handleMouseEnter = (id) => {
    setIsMenuOpen(id);
  };

  const handleMouseLeave = () => {
    setIsMenuOpen("");
  };

  return (
    <div className="flex-1 overflow-x-auto gray-scrollbar">
      <div className={`flex items-center gap-14`}>
        <a
          className="hidden font-bold text-red-600 hover:text-gray-800 animate-bounce text-nowrap"
          href="https://imgs.awahed.com/media/media/Ramadan-flyer2025.pdf"
          target="_blank"
        >
          {router.locale === "ar" ? "تصفح عروض رمضان" : "Browse Ramadan offers"}
        </a>
        {megaMenuTreeData?.length > 0 &&
          isClient &&
          megaMenuTreeData?.map((cat) => {
            const parentUrl = `/cp/${cat?.url_key}`;
            const modifiedData = modifyMegaMenuTreeData(cat?.children_data);

            return (
              <div
                key={cat?.id}
                className="py-4 font-semibold uppercase "
                onMouseEnter={() => handleMouseEnter(cat?.id)}
                onMouseLeave={handleMouseLeave}
              >
                <Link
                  className="block font-bold uppercase cursor-pointer text-nowrap"
                  href={`/${parentUrl}`.replace("//", "/")}
                  prefetch={false}
                >
                  {cat?.name}
                </Link>

                {modifiedData?.length ? (
                  <FloatMenu
                    {...{
                      parentUrl,
                      sku_list: cat?.sku_list,
                      banners: cat?.banners,
                      children_data: modifiedData,
                      isMenuOpen: isMenuOpen === cat?.id,
                    }}
                  />
                ) : null}
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default MegaMenu;
